module.exports = __webpack_public_path__ + "img/icons_all_sports-or.3ae79cc5.png";